<template>
    <section class="login_section">
    <div class="login-wrap">
        <div class="login-div">
            <div class="login-header"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-167"></div>
            <div class="login-form-div">
                <h1 class="heading-45">Welcome <br/>OhMyMeds Patients.</h1>
                <div class="text-block-201" style="font-size: 20px;">Update Your Password to Access Account</div>
                <div class="text-block-203">All of your prescriptions and information updated in our system which will cause zero gaps in treatment.</div>
                <div class="text-block-203">All we need you to do is enter the email address associated with your OhMyMeds account and we will send you a link to reset your password.</div>
                <div class="div-block-1041">
                    <div class="w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-5" @submit.prevent="onSubmit">
                            <input class="login-user w-input" style="border-radius: 5px;" maxlength="256" name="email-or-phone" v-model="email" data-name="Email Or Phone" placeholder="Enter your email" type="text" id="email-or-phone">
                            <button class="submit-button-6 w-button" :disabled="submitted" style="margin-top:12px">
                                <div v-if="submitted">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                        <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                        </circle>
                                    </svg>
                                </div>
                                <div v-else>
                                    <div class="">Request Reset Email</div>
                                </div>
                            </button>
                            <div class="text-block-1586">Already Updated Password?</div>
                            <div class="text-block-1587">
                                <a href="/login" class="link-80">Click Here to Login to Account</a>
                            </div>
                        </form>
                        <div class="w-form-done" style="display:block;padding-top:5px; background-color: rgb(212, 239, 238);" v-if="success">
                    <div>We have emailed you a link to reset your password.</div>
                </div>
                <div class="w-form-fail" style="display:block;" v-if="err">
                    <div>No user found with that email address.
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="height:280px"></div>
</section>
    

</template>

<script>
export default {
    name: 'ResetPassword',
    props: ['baseUrl'],
    data() {
        return {
            email: null,
            submitted: false,
            success: false,
            err:false
        }
    },
    methods: {
        onSubmit() {
            this.submitted = true;
            this.err = false;
            this.$axios.post( `${this.baseUrl}/api/forgot-password`, {
                email: this.email.toLowerCase(),
            }).then(response => {
                if (response.data.status == 'success') {
                    this.success= true;
                    this.submitted = false;
                } else {
                    this.submitted = false;
                    this.err = true;
                }

            });

        },
    }
}
</script>